import React from "react";
import dynamic from "next/dynamic";
// import BlogAuthor from "./author";
import BlogDetailBanner from "./banner";
const BlogDetailPost = dynamic(() => import("./detail-post"),{ssr: true});
import { parseHtml } from "@/utils/common";
const Download = dynamic(() => import("./DownloadWhitepaper"),{ssr: true});
const BuildSection = dynamic(() => import("@/Components/BuildSection"),{ssr: true});
import styles from "./detail-post/NewBlogPost.module.scss";
// import dynamic from "next/dynamic";

/* const BookConsultant = dynamic(
  () => import("../services/service-book-consultant/bookconsultant"),
);
const BlogArticles = dynamic(() => import("./blog-articles/blog-articles"));
const BlogDigital = dynamic(() => import("./blog-digital/blog-digital"));
const BlogMigration = dynamic(() => import("./blog-migration/blog-migration")); */

// Define block types
interface BaseBlock {
  __component: string;
  [key: string]: any;
}

interface FaqBlock extends BaseBlock {
  __component: "blocks.faq";
  faqs?: any[];
}

interface ParagraphBlock extends BaseBlock {
  __component: "blocks.blog-paragraph";
  content?: string;
}

interface RelatedArticlesBlock extends BaseBlock {
  __component: "blocks.related-articles";
  articles?: any[];
}

interface CtaBlock extends BaseBlock {
  __component: "blocks.cta";
  title?: string;
}

type Block = FaqBlock | ParagraphBlock | RelatedArticlesBlock | CtaBlock;

// Props type
interface BlogDetailsProps {
  blocks: {
    authors?: any[];
    blocks?: Block[];
    [key: string]: any;
  };
}

const BlogDetails: React.FC<BlogDetailsProps> = ({ blocks }) => {
  const blog = blocks?.data?.[0]?.attributes;

  const faq = blog?.blocks?.find(
    (item: any) => item.__component === "blocks.faq",
  ) as FaqBlock | undefined;

  return (
    <div className="blog-detail-development bg-one">
      <BlogDetailBanner data={blocks} />

      {blog?.popluarity === "whitepaper" ? (
        <>
          <div className="py-[56px] lg:py-[80px] xl:py-[80px] bg-white ">
            <div className="container">
              <div className="grid grid-cols-12 justify-center gap-6">
                <div className="col-span-1 lg:block hidden"></div>
                <div className="lg:col-span-10 col-span-12 space-y-6">
                  <div className="space-y-6">
                    <div
                      className={`my-[40px] space-y-6 new-blog-post ${styles.newBlogPost}`}
                    >
                      {parseHtml(blog.whitepaper)}
                    </div>
                  </div>
                  <Download data={blocks} />
                </div>
                <div className="col-span-1 lg:block hidden"></div>
              </div>
            </div>
          </div>
          {/* {blog?.authors.data && blog.authors.data.length > 0 && (
            <BlogAuthor data={blog.authors} />
          )} */}
        </>
      ) : (
        <>
          {blog?.blocks && blog.blocks.length > 0 && (
            <>
              {blog.blocks.map((block: any, i: number) => (
                <React.Fragment key={i}>
                  {block.__component === "blocks.blog-paragraph" && (
                    <BlogDetailPost
                      block={block}
                      faq={faq}
                      authors={blog.authors}
                    />
                  )}

                  {/* {block.__component === "blocks.related-articles" && (
                    <BlogArticles block={block} />
                  )} */}

                  {block.__component === "blocks.cta" && (
                    <BuildSection key={i} data={block} />
                  )}
                </React.Fragment>
              ))}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default BlogDetails;
